import React from "react";
import { Wrapper, Head, SubTitle, Title, CharType, Content } from './styled';

//@ts-ignore
import { IoClose } from "react-icons/io5";
import TypeBadge from "../TypeBadge";

type Activity = {
  type: string;
  label: string;
};

interface ActivityPopupProps {
  onClose: () => void;
};

const ActivityPopup: React.FC<ActivityPopupProps> = ({ onClose }) => {
  const data: Activity[] = [
    { type: 'H', label: 'Habit' },
    { type: 'A', label: 'Action' },
    { type: 'D', label: 'Decision' },
    { type: 'T', label: 'Task' }
  ];

  return (
    <Wrapper>
      <Head>
        <Title>
          Type Of Activity
        </Title>

        <IoClose onClick={onClose} style={{ cursor: 'pointer', color: "#737373", fontSize: 16 }} />       
      </Head>

      {data.map((ele, index) => (
        <Content role="listitem" key={index}>
          <TypeBadge type={ele?.type} />
          <SubTitle>
            {ele?.label}
          </SubTitle>
        </Content>
      ))}
    </Wrapper>
  );
};

export default ActivityPopup;
